import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppLoadingService } from '../../services/apploading.service';
import { GeneralService } from '../../services/general.service';
import { HttpService } from 'src/app/core/http/http.service';
import { RequestAuthorizationService } from '../../services/request-authorization.service';
import { RequestStatus } from '../../models/requestStatus';
import { API } from 'src/app/configs';
import { Subscription } from 'rxjs';
import { RequestService } from '../../services/request.service';

declare var $;

@Component({
  selector: 'dialog-request-list',
  templateUrl: 'dialog-request-list.component.html',
  styleUrls: ['./dialog-request-list.component.scss']
})
export class DialogRequestListComponent implements OnInit, OnDestroy {

  list:any = [];
  total:any = {};
  loadingList = false;

  error = false;

  page = 0;

  requestType:any = {};

  iconStatus:any = new RequestStatus().getIcons();

  
  filterOptions:any = [
    { type: 'title', filterType: 'status', title: 'Filtros'},
    { id: 1, title: 'Pendente', filter:'status' },
    { id: 2, title: 'Autorizada', filter:'status' },
    { id: -1, title: 'Rejeitada', filter:'status' },
  ];

  filterSelected:any = [this.filterOptions[0], this.filterOptions[1]];

  protected transactionDataSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    protected gs: GeneralService,
    protected als: AppLoadingService,
    protected httpService: HttpService,
    protected rs: RequestService,
  ) { 

    this.requestType = this.gs.getRequestTypes();
    
    this.filterOptions.push({ type: 'title', filterType: 'type', title: 'Tipo' });
    Object.entries(this.requestType).map(item => {
      this.filterOptions.push({id : parseInt(item[0]), title:item[1]['title'], filter:'type'});
    });

    this.transactionDataSubscription = this.gs.transactionData.subscribe(result => {
      if(['request'].indexOf(result?.method) > -1 && result?.action == 'reload'){
        this.loadData(null, 1);
      }
    });

  }

  ngOnInit(){
    this.loadData(null, 1);
  }

  ngOnDestroy(){

  }

  applyFilter(filterItem){

    if(filterItem == 'all')
        this.filterSelected = this.filterOptions;
    else {
        if(!this.filterSelected.filter(item => item.id == filterItem.id && item.filter == filterItem.filter)?.length)
            this.filterSelected.push(filterItem);
        else
            this.filterSelected = this.filterSelected.filter(item => !(item.id == filterItem.id && item.filter == filterItem.filter));
    }

    this.loadData(null, 1);
  }

  
  async loadData(event = null, page:any = 'next') {

    this.page = page == 'next'? this.page + 1 : page;

    if(this.loadingList){
      if (event)
          event.target.complete();

      this.loadingList = false;

      return;
    }

    this.error = false;
    this.loadingList = true;

    let status = [];
    this.filterSelected.filter(item => item.filter == 'status').map(item => status.push(item.id));

    let type_id = [];
    this.filterSelected.filter(item => item.filter == 'type').map(item => type_id.push(item.id));

    return await this.httpService.post<any>(API.person.general.request.list,{
      current_page : this.page,
      made : true,
      status : (!!status.length? status : this.filterOptions.filter(item=> item.filter=='status').map(item => item.id)),
      ...!!type_id.length? { type_id : type_id} : {}
    })
    .then(async (result) => {

      result.list = result.list.map(item => {
        item.avatar = this.gs.adjustAvatarFiles(item);
        item.avatarFiles = this.gs.getAvatarFile(item.avatar);


        if (typeof item?.ad_cover === 'string' && item?.ad_cover != '{}')
          item.adCoverFiles = this.gs.getAvatarFile(item.ad_cover);
          /*
        if(item?.ad_cover || item?.cover){
          item.cover = typeof item?.cover === 'string'? JSON.parse(item.cover) : (typeof item?.ad_cover === 'string'? JSON.parse(item.ad_cover) : (item?.ad_cover || item?.cover));          
          item.cover = this.gs.getAvatarFile(item.cover);
        }*/

        item.payload = (typeof item?.payload === 'string' && item?.payload!='{}')? JSON.parse(item.payload): {};
        if(item.expiration)
          item.expiration+=' 00:00:00';
        return item;
      })

      this.list = this.page == 1? result.list : this.list.concat(result.list);

      this.total = result?.total || {};


    })
    .catch((error) => {
      this.error = true;
      this.list = [];
      this.gs.error(error);
    })
    .finally(() => {
      if (event)
        event.target.complete();
        
      this.loadingList = false;
    });
     
  }  

  imgDidLoad(event){
    this.gs.imgDidLoad(event);
  }

  async openMenu(event, item){
    
    this.rs.setRequestAction(event, item, { 
      admin : false
    });

  }

}